/**
 * Lightweight GA4 event wrapper.
 * Safe to call even when gtag hasn't loaded yet — silently no-ops.
 */
export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;
  try {
    window.gtag("event", name, params);
  } catch {
    /* swallow — analytics must never break the app */
  }
}

export const events = {
  phoneCall: () =>
    trackEvent("phone_call", {
      event_category: "engagement",
      event_label: "click_to_call",
    }),
  estimateFormSubmit: () =>
    trackEvent("form_submit", {
      event_category: "engagement",
      event_label: "estimate_request",
    }),
  estimateModalOpen: () =>
    trackEvent("modal_open", {
      event_category: "engagement",
      event_label: "estimate_modal",
    }),
};
